import { createSelector } from 'reselect';
import DespatchParticularsReceptacleTypeColumns
  from '../../containers/DespatchMeasurementsDailyEvolutionColumns';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MEASUREMENTS_DAILY_EVOLUTION.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_MEASUREMENTS_DAILY_EVOLUTION.isLoading;

export const getData = state => state.reporting.DESPATCH_MEASUREMENTS_DAILY_EVOLUTION.data;

export const getColumns = createSelector(getData, DespatchParticularsReceptacleTypeColumns);
